import { render } from "./ContentPatientPermission.vue?vue&type=template&id=ada1efbe&ts=true"
import script from "./ContentPatientPermission.vue?vue&type=script&lang=ts"
export * from "./ContentPatientPermission.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Permissions/ContentPatientPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ada1efbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ada1efbe', __exports__)) {
    api.reload('ada1efbe', __exports__)
  }
  
  module.hot.accept("./ContentPatientPermission.vue?vue&type=template&id=ada1efbe&ts=true", () => {
    api.rerender('ada1efbe', render)
  })

}


export default __exports__